<template>
  <el-dialog
    title="航线上传"
    :close-on-click-modal="false"
    :visible.sync="dialogVisiable"
    :append-to-body="true"
    @close="hide"
    custom-class="routePlanningResultContainer"
    width="271px"
  >
    <div class="dataContainer">
      <div class="separator"></div>
      <div class="resultInfoContainer">
        <img :src="resultImg" class="resultImg" />
        <div style="margin-left: 8px; width: 137px">{{ message }}</div>
        <div class="btn" @click="hide">确定</div>
        <div class="btn" @click="hide">取消</div>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/javascript">
import successImg from "../../../assets/img/taskPlan/successImg.png";
import errorImg from "../../../assets/img/taskPlan/errorImg.png";
export default {
  name: "RoutePlanningResult",
  data() {
    return { dialogVisiable: false, resultImg: errorImg, message: "上传失败" };
  },
  props: ["uploadSuccess", "showResult"],
  methods: {
    hide() {
      this.$emit("changeResultStatus", false);
    },
  },
  watch: {
    showResult: function (nval, oval) {
      if (nval) {
        this.$data.dialogVisiable = true;
      } else {
        this.$data.dialogVisiable = false;
      }
    },
    uploadSuccess: function (nval, oval) {
      if (nval) {
        this.$data.resultImg = successImg;
        this.$data.message = "上传成功";
      } else {
        this.$data.resultImg = errorImg;
        this.$data.message = "上传失败";
      }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/mapCss/routePlanningResult.css";
</style>
<style>
.routePlanningResultContainer {
  width: 271px !important;
  height: 112px !important;
  background: rgba(28, 35, 64, 0.9);
  border: 1px solid #0083fd;
  border-radius: 6px;
  margin-top: calc(25% - 61px) !important;
}

.routePlanningResultContainer .el-dialog__header {
  height: 18px;
  font-size: 18px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 500;

  padding-top: 13px;
  padding-left: 17px;
  padding-bottom: 13px;
}

.routePlanningResultContainer .el-dialog__header .el-dialog__title {
  height: 18px;
  color: #ffffff;
  line-height: 18px;
  float: left;
}

.routePlanningResultContainer .el-dialog__header .el-dialog__headerbtn {
  position: absolute;
  right: 16px;
  top: 18px;
}
.routePlanningResultContainer .el-dialog__header .el-icon-close {
  color: #ffffff;
}
.routePlanningResultContainer .el-dialog__header .el-icon-close:hover {
  color: #0083fd;
}
.routePlanningResultContainer .el-dialog__body {
  padding: 0px 16px 22px 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanningResult.vue